export function setup_media_recorder(audio, push_audio_chunk) {
    let media_recorder;
    let audio_codecs = null;

    if (typeof MediaRecorder !== 'undefined') {
        if (MediaRecorder.isTypeSupported('audio/webm; codecs=opus')) {
            media_recorder = new MediaRecorder(audio, { mimeType: 'audio/webm; codecs=opus' });
            audio_codecs = 'audio/webm; codecs=opus';
        } else if (MediaRecorder.isTypeSupported('audio/ogg; codecs=opus')) {
            media_recorder = new MediaRecorder(audio, { mimeType: 'audio/ogg; codecs=opus' });
            audio_codecs = 'audio/ogg; codecs=opus';
        } else if (MediaRecorder.isTypeSupported('audio/mp4; codecs=mp4a.40.2')) {
            media_recorder = new MediaRecorder(audio, { mimeType: 'audio/mp4; codecs=mp4a.40.2' });
            audio_codecs = 'audio/mp4; codecs=mp4a.40.2';
        } else if (MediaRecorder.isTypeSupported('audio/webm')) {
            media_recorder = new MediaRecorder(audio, { mimeType: 'audio/webm' });
            audio_codecs = 'audio/webm';
        } else if (MediaRecorder.isTypeSupported('audio/mp4')) {
            media_recorder = new MediaRecorder(audio, { mimeType: 'audio/mp4' });
            audio_codecs = 'audio/mp4';
        } else {
            media_recorder = new MediaRecorder(audio); // Let browser decide
            audio_codecs = 'default';
        }
    } else {
        // handleErrorSentry(Error("MediaRecorder not supported in this browser"), "generic");
        return;
    }

    media_recorder.onerror = (error) => {
        // handleErrorSentry(error, "onError");
    }
    media_recorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
            push_audio_chunk(event.data);
        }
    };

    return { 
        media_recorder,
        audio_codecs,
    };
}

export async function grab_wakelock() {
    try {
        const sentinel = await navigator.wakeLock?.request("screen");
        return sentinel
    } catch (error) {
        console.log(error);
        return null;
    }
}

export function clean_wakelock(wakeLock) {
    if (wakeLock) {
        wakeLock.release();
        wakeLock = null;
    }
}

export function clean_microphone(audio, mediaRecorder) {
    if (audio) {
        console.log("cleaned audio");
        audio.getTracks().forEach(track => track.stop());
    }

    if (mediaRecorder) {
        console.log("cleaned mediarecorder");
        mediaRecorder.stop();
        mediaRecorder.stream.getTracks().forEach(track => track.stop());
    }
}

export function areAllTracksLive(mediaRecorder) {
    if (!mediaRecorder?.stream) return false;
  
    return mediaRecorder.stream.getTracks().every(track => track.readyState === 'live');
}

export function areAllTracksLiveAudioNode(source) {
    if (!source?.mediaStream) return false;

    return source.mediaStream.getTracks().every(track => track.readyState === 'live');
}


export function downloadAudioBlob(blob, filename = 'audio.webm') {
    const url = URL.createObjectURL(blob);
  
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
  
    document.body.appendChild(a);
    a.click();
  
    // Clean up
    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }